import React, { createContext, useContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(
    localStorage.getItem('lang') || 'en'
  );
  const [isChanging, setIsChanging] = useState(false);

  useEffect(() => {
    // Set the initial language
    i18n.changeLanguage(currentLanguage);
  }, [i18n, currentLanguage]);

  const changeLanguage = async (languageCode) => {
 
    setIsChanging(true);
    setCurrentLanguage(languageCode);
    localStorage.setItem('lang', languageCode);
    await i18n.changeLanguage(languageCode);

    setIsChanging(false);
  };

  const value = {
    currentLanguage,
    changeLanguage,
    isChanging,
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
